import React, { useEffect, useState } from "react";
import "../css/blogcontainer.css";
// import Loading from "./Loading";
import SmallArticleItem from "./SmallArticleItem";
// import InfiniteScroll from "react-infinite-scroll-component";

function Category(props) {
  document.title=`${props.category} - BlogPoint | Abid Adhikari`

  // eslint-disable-next-line
  const [loading, setLoading] = useState(true);
  let totalArticle = 0;
  const [lastPage, setLastPage] = useState(null);
  const [page, setPage] = useState(1);
  const [articles, setArticles] = useState([]);

  const[category,setCategory]=useState(props.category);
  const pageSize = 10;

  props.setProgress(0);
 

  const checkPage = (totalArticle) => {
    let lastpage = Math.ceil(totalArticle / pageSize);
    setLastPage(lastpage);
  };

  const apiCall = async () => {
    const hostname = process.env.REACT_APP_API_URL;
    const response = await fetch(
      `${hostname}blog/categories?category=${props.category}&pageSize=${pageSize}&page=${page}`
    );
    const data = await response.json();
    if (!data.success) {
      return;
    }
    totalArticle = data.totalArticle;
    props.setProgress(70);
    setArticles(() => {
      return data.articles;
    });
    checkPage(totalArticle);
    setLoading(false);
  };

  useEffect(()=>{
    setPage(1)
  },[category])

  // main yei ho
  useEffect(() => {
    setCategory(props.category)
    props.setProgress(10);
    setLoading(true);
    apiCall(pageSize, page);
    props.setProgress(100);
    // eslint-disable-next-line
  }, [page, props.category]);



  const scrollTop = () => {
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    setLoading(true);
    setPage(page + 1);
    scrollTop();
  };

  const handlePrev = () => {
    if (page === 1) {
      return;
    }
    setLoading(true);
    setPage(page - 1);
    scrollTop();
  };
  return (
    <>
      <div className="blogcontainer">
        {/* {loading ? (
          <>
            <div className="loadingcontainer">
              <Loading />
            </div>
          </>
        ) : undefined} */}

        {loading ? undefined : (
          <>
            {articles.map((e) => {
              return (
                <SmallArticleItem
                  key={e._id}
                  title={e.title}
                  imglink={e.imglink}
                  slug={e.slug}
                />
              );
            })}
          </>
        )}
      </div>
      <div className="prevnextbtns">
        <button
          onClick={handlePrev}
          className={page === 1 ? "disabledbtn" : undefined}
          disabled={page === 1 ? true : false}
        >
          PREV
        </button>
        <span>{page}</span>
        <button
          onClick={handleNext}
          className={page === lastPage ? "disabledbtn" : undefined}
          disabled={page === lastPage ? true : false}
        >
          Next
        </button>
      </div>
    </>
  );
}

export default Category;
